import React, { useEffect, useState } from 'react'
import axios from "axios"
import { useTranslation } from "react-i18next"
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { RolesList, RolesDisableList } from '../components/utils/roleConfigList'
import { Checkbox } from '@mui/material'
import './pages.css'
import { M_InputTextField, M_Button, DefaultURl } from 'src/M_Components'

export const RoleConfigCrud = ({ toastMessages, handleTabClose }) => {
    const passOperation = sessionStorage.getItem('operation') !== null ? sessionStorage.getItem('operation') : 'Error'
    const sessionLine = sessionStorage.getItem('rolesLine') !== null && sessionStorage.getItem('rolesLine') !== undefined ? JSON.parse(sessionStorage.getItem('rolesLine')) : 'Error'
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const [roleName, setRoleName] = useState('')
    const [permissions, setPermissions] = useState([])
    const [operation, setOperation] = useState(passOperation)
    const [passLine, setPassLine] = useState('')
    const [isFirst, setIsFirst] = useState(true)

    const tempRoleName = 'Admin'
    const { t } = useTranslation()
    const columns = ["List", "Create", "Edit", "Delete", "Audit"]
    const sessionKeys = ['operation', 'roleName', 'permissions', 'passLine', 'isFirst']

    // const headerSize = document.body.getElementsByClassName('divTabs')[0]?.offsetHeight || 0
    useEffect(() => {
        if (isFirst) {
            sessionStorage.removeItem('rolesLine')
            sessionStorage.removeItem('operation')
            setPassLine(sessionLine)
            setIsFirst(false)
        }
        getSessionStorageData(id)
        sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
    }, [])

    const sessionStorageMachine = (id, key, value) => {
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempRN = JSON.parse(sessionStorage.getItem(`${sessionID}roleName`))
        const tempP = JSON.parse(sessionStorage.getItem(`${sessionID}permissions`))
        const tempL = JSON.parse(sessionStorage.getItem(`${sessionID}passLine`))
        const tempIF = JSON.parse(sessionStorage.getItem(`${sessionID}isFirst`))
        if (tempO || tempRN || tempP || tempL || tempIF) {
            setOperation(tempO)
            setRoleName(tempRN)
            setPermissions(tempP)
            setPassLine(tempL)
            setIsFirst(tempIF)
            return
        }
        getRefresh(sessionLine)
    }

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach(key => {
            sessionStorageMachine(id, key, key)
        })
    }, [id, operation, roleName, permissions, passLine])


    const getRefresh = (line) => {
        const lineRole = line ? line : passLine
        let tempArray = JSON.parse(RolesList).sort((a, b) => a.Name.localeCompare(b.Name))
        if (operation === 'Create') {
            setPermissions(tempArray)
        } else {
            if (lineRole === 'Error') {
                handleTabClose(JSON.parse(id))
                toastMessages('error', '', t("SelectedLine"))
                return
            }
            console.log('passLine', lineRole)

            setRoleName(lineRole.Name)

            axios.get(`${DefaultURl}viewroledetails/${lineRole.Name}`).then(response => {
                toastMessages('success', 'Data received', '')
                response.data.forEach(perm => {
                    columns.forEach(col => {
                        if (perm.match(col)) {
                            tempArray = tempArray.map(obj => {
                                if (obj.Value == perm.split(col)[0]) {
                                    obj[col] = true
                                    return obj
                                } else return obj
                            })
                        }
                    })
                })
                setPermissions(tempArray)
            }).catch(error => {
                handleTabClose(JSON.parse(id))
                toastMessages('error', error.message, '')
                setPermissions(tempArray)
            })
        }
    }

    const checkboxBody = (e, items) => {
        if (RolesDisableList.includes(`${e.Value}${items}`) || operation === 'View') {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <Checkbox
                        // icon={'pi pi-circle-fill'}
                        disabled={true}
                        checked={e[items]}
                        onChange={(elem) => changeTable(e.Name, items, elem.target.checked)}
                        sx={{ padding: 0 }}
                    />
                </div>
            )
        } else {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <Checkbox
                        checked={e[items]}
                        onChange={(elem) => changeTable(e.Name, items, elem.target.checked)}
                        sx={{
                            padding: 0, color: 'var(--color-blue)', '&.Mui-checked': {
                                color: 'var(--color-blue)',
                            },
                        }}
                    />
                </div>
            )
        }
    }

    const changeTable = (name, field, value) => {
        setPermissions(permissions.map(obj => {
            if (obj.Name == name) {
                obj[field] = value
                return obj
            } else return obj
        }))
    }

    const onSave = () => {
        const permissionsArray = []
        permissions.forEach(obj => {
            Object.entries(obj).forEach(keyValue => {
                if (keyValue[0] !== 'Name' && keyValue[0] !== 'Value' && keyValue[1]) {
                    permissionsArray.push({
                        "Key": "PERMISSION",
                        "Value": `${obj.Value}${keyValue[0]}`
                    })
                }
            })
        })

        if (operation === 'Create' || operation === 'Copy') {
            axios.post(`${DefaultURl}viewroledetails/${roleName}`, permissionsArray).then(response => {
                console.log(response)
                toastMessages('success', '', '')
                setTimeout(() => {
                    handleTabClose(JSON.parse(id))
                }, 1000);
            }).catch(error => {
                console.log(error)
            })
        } else {
            axios.put(`${DefaultURl}viewroledetails/${roleName}?id=${passLine.Id}`, permissionsArray).then(response => {
                console.log(response)
                toastMessages('success', '', '')
                setTimeout(() => {
                    handleTabClose(JSON.parse(id))
                }, 1000);
            }).catch(error => {
                console.log(error)
            })
        }
    }

    return (
        <div className='firstDivContainer'>
            <div className='secoundDiv'>
                <div className='ColumnsButtonsDiv'>
                    <M_Button
                        tooltip={t("RefreshTable")}
                        icon={<i className="pi pi-refresh headerIcon"></i>}
                        label={t("RefreshTable")}
                        onClick={() => getRefresh()}
                    />
                    <M_Button
                        tooltip={t("Save")}
                        icon={<i className="pi pi-save headerIcon"></i>}
                        label={t("Save")}
                        onClick={() => onSave()}
                    />
                </div>
            </div >
            <div className='tableDiv'>
                <div style={{ width: '250px' }}>
                    <M_InputTextField disabled={operation === 'View' ? true : false} label={'Role Name'} value={roleName} onChange={(e) => setRoleName(e.target.value)} />
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                <DataTable value={permissions} size='small' paginator rows={15} tableStyle={{ minWidth: '50rem', maxWidth: '80%' }}>
                    <Column field='Name' header='' style={{ minWidth: '250px', width: '250px', maxWidth: '250px' }} filterMatchMode="contains" >items</Column>
                    {columns.map((items, index) => (
                        items === 'List' ?
                            <Column key={index} field={items} header={'Read'} body={(e) => checkboxBody(e, items)}>items</Column>
                            :
                            <Column key={index} field={items} header={items} body={(e) => checkboxBody(e, items)}>items</Column>
                    ))}
                </DataTable>
            </div>
        </div >
    )
}
